import Transactions from 'views/Transactions/FinanceTransactions.jsx';
import Truckers from 'views/Truckers/Truckers.jsx';
// @material-ui/icons
import LocalShipping from '@material-ui/icons/LocalShipping';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SwapHoriz from '@material-ui/icons/SwapHoriz';
import { AssignmentTurnedIn } from '@material-ui/icons';
import AdminApproveTransaction from 'views/AdminApproveTransaction/AdminApproveTransaction.jsx';
import DashboardRedirect from '../views/Dashboard/DashboardRedirect';

const financeDashRoutes = [
  {
    path: '/finance/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: DashboardRedirect,
  },
  {
    collapse: true,
    path: '/finance/approve',
    name: 'Approve',
    icon: AssignmentTurnedIn,
    state: 'openApprove',
    views: [
      {
        path: '/finance/approve/transaction',
        name: 'Transaction',
        mini: 'T',
        component: AdminApproveTransaction,
      },
    ],
  },
  {
    path: '/finance/transactions',
    name: 'Transactions',
    icon: SwapHoriz,
    component: Transactions,
  },
  {
    path: '/finance/truckers',
    name: 'View Truckers',
    icon: LocalShipping,
    component: Truckers,
  },
  {
    redirect: true,
    path: '/finance',
    pathTo: '/finance/dashboard',
    name: 'Dashboard',
  },
];
export default financeDashRoutes;
